import { Link } from 'react-router-dom';
import { Heart, Eye } from 'lucide-react';

const categoryLabels = {
  photography: 'Photography',
  fine_art: 'Fine Art',
  film: 'Film',
  music: 'Music',
  poetry: 'Poetry',
  short_story: 'Short Story',
};

export default function ArtworkCard({ artwork, featured = false, isFavorited = false, onToggleFavorite }) {
  const handleContextMenu = (e) => {
    e.preventDefault();
    alert('This artwork is protected by copyright. \u00a9 Scott McGuire / mortalworks.art');
  };

  const handleDragStart = (e) => {
    e.preventDefault();
  };

  const handleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onToggleFavorite) onToggleFavorite(artwork.id);
  };

  return (
    <Link 
      to={`/artwork/${artwork.id}`}
      className={`art-card block bg-[#121212] overflow-hidden group ${featured ? 'row-span-2' : ''}`}
      data-testid={`artwork-card-${artwork.id}`}
    >
      {/* Image Container with Protection */}
      <div 
        className="relative aspect-[4/5] overflow-hidden protected-wrapper screenshot-guard"
        onContextMenu={handleContextMenu}
      >
        <img
          src={artwork.thumbnail_url || artwork.watermark_url || artwork.preview_url || artwork.image_url}
          alt={artwork.title}
          className="art-image w-full h-full object-cover"
          draggable="false"
          onDragStart={handleDragStart}
          loading="lazy"
          style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
        />
        
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="text-[#F5F5F0] text-sm uppercase tracking-widest">View Details</span>
        </div>
        
        {/* Favorite Button */}
        {onToggleFavorite && (
          <button
            onClick={handleFavorite}
            className="absolute top-4 right-4 z-10 p-2 bg-black/40 backdrop-blur-sm hover:bg-black/60 transition-colors"
            data-testid={`favorite-btn-${artwork.id}`}
          >
            <Heart
              size={18}
              className={isFavorited ? 'fill-[#D4AF37] text-[#D4AF37]' : 'text-white/80'}
            />
          </button>
        )}
        
        {/* Category Badge */}
        <div className="absolute top-4 left-4">
          <span className="category-badge">
            {categoryLabels[artwork.category] || artwork.category}
          </span>
        </div>
        
        {/* Featured Badge */}
        {artwork.is_featured && !onToggleFavorite && (
          <div className="absolute top-4 right-4">
            <span className="badge badge-gold">Featured</span>
          </div>
        )}
        
        {/* Sold Badge */}
        {artwork.is_sold && (
          <div className={`absolute ${onToggleFavorite ? 'top-14' : 'top-4'} right-4`}>
            <span className="badge badge-danger">Sold</span>
          </div>
        )}
      </div>
      
      {/* Info */}
      <div className="p-4 lg:p-6">
        <h3 className="font-serif text-lg lg:text-xl text-[#F5F5F0] tracking-tight truncate">
          {artwork.title}
        </h3>
        <p className="text-[#71717A] text-sm mt-1">
          by {artwork.artist_name}
        </p>
        
        <div className="mt-4 flex items-center justify-between">
          <span className="price-tag text-lg">
            ${artwork.price?.toFixed(2)}
          </span>
          
          <div className="flex items-center gap-4 text-[#71717A]">
            <span className="flex items-center gap-1 text-sm">
              <Eye size={14} />
              {artwork.view_count || 0}
            </span>
            <span className="flex items-center gap-1 text-sm">
              <Heart size={14} className={isFavorited ? 'fill-[#D4AF37] text-[#D4AF37]' : ''} />
              {artwork.like_count || 0}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
